
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Client, ClientStatus, JuridicalPerson } from '@/types/Catalogs'
import DateSelector from '@/components/generic/DateSelector.vue'
import LoadingMask from '@/components/generic/LoadingMask.vue'
import { MessageError } from '@/components/generic/MessageHandling.vue'
import catalogsService from '@/services/CatalogsService'
import { RoleNames } from '@/types/Auth'
import userInfoStore from '@/store/userInfo'
import moment from 'moment'
import DateFormat from '@/services/DateFormat'
import { CLIENT_REGEXPS } from '@/types/RegExpressions'

@Component({
  components: {
    DateSelector,
    LoadingMask,
    MessageError
  }
})
export default class AdminClientForm extends Vue {
  @Prop({ required: true, default: 0 })
  id: number

  @Prop({ required: true, default: '' })
  title: string

  @Prop({ required: false, default: false })
  readOnly: boolean

  @Prop({ required: false, default: false })
  editButton: boolean

  loading = false

  form = Client.getIntanceForEdit()
  statusOptions: any[] = []
  juridicalPersonOptions = [
    { value: JuridicalPerson.MORAL, text: 'Persona moral' },
    { value: JuridicalPerson.PHYSICAL, text: 'Persona física' }
  ]
  countriesOptions = catalogsService.getCountries().map(it => { return { value: it, text: it } })
  mexicoStatesOptions = [ { value: '', text: '-- Seleccione estado --' } ].concat(catalogsService.getMexicoStates().map(it => { return { value: it, text: it } }))
  regexRfcPersonaFisica = CLIENT_REGEXPS.regexRfcPersonaFisica
  regexRfcPersonaMoral = CLIENT_REGEXPS.regexRfcPersonaMoral
  regexPhone = CLIENT_REGEXPS.regexPhone
  regexZipCode = CLIENT_REGEXPS.regexZipCode
  regexComercialCharge = CLIENT_REGEXPS.regexComercialCharge
  regexMinLicenses = CLIENT_REGEXPS.regexMinLicenses
  regexClientCode = CLIENT_REGEXPS.regexClientCode
  regexStpClabe = CLIENT_REGEXPS.regexStpClabe

  creationDate = ''
  updateDate = ''
  verificationDate = ''

  clientBackup = ''

  mounted () {
    this.init()
  }

  init () {
    if (this.id) {
      this.loading = true
      catalogsService.getClientById(this.id).then(data => {
        data.address.intNumAddress = data.address.intNumAddress || ''
        data.comercialCharge = data.comercialCharge || ''
        data.minimumLicenses = data.minimumLicenses || 0
        data.startDate = data.startDate ? moment(data.startDate).toDate() : '' as any

        this.creationDate = new DateFormat(data.creationDate).toDateTimeString() // moment(data.creationDate).format('MMMM DD, YYYY - HH:mm')
        this.verificationDate = data.verificationDate ? new DateFormat(data.verificationDate).toDateTimeString() : '- - / - - / - - - -'
        this.updateDate = data.updateDate ? new DateFormat(data.updateDate).toDateTimeString() : ' - - / - - / - - - -'

        this.form = data
        this.clientBackup = JSON.stringify(this.form)
        this.createStatusOptions()
        this.$validator.reset()
      }).finally(() => {
        this.loading = false
      })
    } else {
      this.createStatusOptions()
    }
  }

  validateState (ref: any) {
    const thiz = this as any
    if (
      thiz.veeFields[ref] &&
      (thiz.veeFields[ref].dirty || thiz.veeFields[ref].validated)
    ) {
      return !thiz.veeErrors.has(ref)
    }
    return null
  }

  onSubmit () {
    this.$validator.validateAll().then(result => {
      if (result) {
        if (JSON.stringify(this.form) === this.clientBackup) {
          // If there are no changes then return to main grid
          this.onCancel()
          return
        }

        this.loading = true
        this.form.updateDate = new Date()
        catalogsService.saveClient(this.form).then((response: Client) => {
          this.form.id = response.id
          this.$emit('saved', this.form)
        }).catch((error) => {
          let messageValues = {
            title: 'Error al guardar el cliente.',
            message: '',
            delay: 10000,
            error: error
          }
          let errorComponent = new MessageError({ propsData: messageValues })
          errorComponent.displayMessage()
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.$bvToast.toast('Revise los campos marcados con error', {
          title: 'Errores en el formulario',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 4500
        })
      }
    })
  }

  onEdit () {
    this.$emit('edit')
  }

  onCancel () {
    this.$emit('close')
  }

  createStatusOptions () {
    this.statusOptions = [
      { value: ClientStatus.APROBACION, text: 'En aprobación', disabled: true },
      { value: ClientStatus.ACTIVO, text: 'Activo', disabled: true },
      { value: ClientStatus.SUSPENDIDO, text: 'Suspendido', disabled: true },
      { value: ClientStatus.BAJA, text: 'Baja', disabled: true }
    ]

    if (this.form.id) {
      switch (userInfoStore.userInfo.role.name) {
        case RoleNames.FINANCES_CONTROL:
          switch (this.form.status) {
            case ClientStatus.APROBACION:
              this.statusOptions[0].disabled = false
              this.statusOptions[1].disabled = false
              break
          }
          break
        case RoleNames.FINANCES_ADMIN:
          switch (this.form.status) {
            case ClientStatus.APROBACION:
              this.statusOptions[3].disabled = false
              break
          }
          break
      }
    } else {
      switch (userInfoStore.userInfo.role.name) {
        case RoleNames.FINANCES_CONTROL:
          this.form.status = ClientStatus.ACTIVO
          break
        case RoleNames.FINANCES_ADMIN:
          this.form.status = ClientStatus.APROBACION
          break
      }
    }
  }
}
